<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <div>
      <!-- 条件搜索 -->
        <div class="table-page-search-wrapper">
          <a-form layout="inline">
            <a-row :gutter="48">
              <a-col :md="6" :sm="24">
                <a-form-item prop="parentId">
                  <span slot="label" ><a-tooltip>{{$t('年级')}}<template slot="title"><!--提示内容--> </template></a-tooltip> </span>
                  <a-select :placeholder="$t('请选择')+$t('年级')" style="width: 100%" v-model="queryParam.parentId" @change="gradeChange" allowClear>
                    <a-select-option v-for="(item, index) in this.gradeList" :value="item.id+''" :key="index">
                      {{ item.gradeName }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item prop="gradeId">
                  <span slot="label" ><a-tooltip>{{$t('班级')}}<template slot="title"><!--提示内容--> </template></a-tooltip> </span>
                  <a-select :placeholder="$t('请选择')+$t('班级')" style="width: 100%" v-model="queryParam.gradeId"  allowClear>
                    <a-select-option v-for="(item, index) in this.classList" :value="item.id+''" :key="index">
                      {{ item.gradeName }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item prop="studentName">
                  <span slot="label" ><a-tooltip>{{$t('学生名称')}}<template slot="title"><!--提示内容--> </template></a-tooltip> </span>
                  <a-input v-model="queryParam.studentName" :maxLength="32" :placeholder="$t('请输入')+'学生名称'" allow-clear />
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item :label="$t('下单开始时间')" prop="createBeginTime">
                  <a-date-picker style="width: 100%" v-model="queryParam.createBeginTime"
                                 :show-time="{defaultValue: moment('00:00:00', 'HH:mm:ss')}"
                                 valueFormat="YYYY-MM-DD HH:mm:ss" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item :label="$t('下单结束时间')" prop="createEndTime">
                  <a-date-picker style="width: 100%" v-model="queryParam.createEndTime"
                                 :show-time="{defaultValue: moment('23:59:59', 'HH:mm:ss')}"
                                 valueFormat="YYYY-MM-DD HH:mm:ss" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="!advanced && 6 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{$t('查询')}}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{$t('重置')}}</a-button>
              </span>
              </a-col>
            </a-row>
          </a-form>
          <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
            <img alt="example" style="width: 100%" :src="previewUrl" />
          </a-modal>
        </div>
        <a-row :gutter="16" class="statistics-summary-row">
          <a-col :md="6" :sm="24">
            <a-card size="small" :bordered="true">
              <div class="statistics-title">订购总数</div>
              <div class="statistics-value">{{ statisticsInfo.totalCount || 0 }}</div>
            </a-card>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-card size="small" :bordered="true">
              <div class="statistics-title">销售总额</div>
              <div class="statistics-value">{{ statisticsInfo.totalPayAmount || 0 }}</div>
            </a-card>
          </a-col>
        </a-row>
        <a-card size="small" :bordered="true" class="style-total-card">
          <div slot="title">款式统计总数</div>
          <a-row :gutter="12">
            <a-col v-for="item in styleTotalList" :key="item.styleName" :md="6" :sm="12" :xs="24">
              <div class="style-total-item">
                <span class="style-total-name">{{ item.styleName }}</span>
                <span class="style-total-count">{{ item.total }}</span>
              </div>
            </a-col>
            <a-col v-if="!styleTotalList.length" :span="24">
              <a-empty description="暂无款式统计数据" />
            </a-col>
          </a-row>
        </a-card>
        <a-row :gutter="16" class="style-pie-row">
          <a-col v-for="(item, index) in styleChartData" :key="item.styleName + index" :md="12" :sm="24">
            <a-card :title="'款式: '+item.styleName" size="small" :bordered="true">
              <div :id="'stylePieChart-' + index" class="style-pie-chart"></div>
            </a-card>
          </a-col>
          <a-col v-if="!styleChartData.length" :span="24">
            <a-empty description="暂无图表数据" />
          </a-col>
        </a-row>
        <a-card size="small" :bordered="true" class="size-table-card">
          <div slot="title">订购尺寸</div>
          <a-table
            class="size-summary-table"
            size="small"
            :columns="sizeTableColumns"
            :data-source="sizeTableData"
            :pagination="false"
            rowKey="styleName"
          />
        </a-card>
      <!-- 操作 -->
        <div class="table-operations">
          <a-button type="primary" @click="handleExport" >
            <a-icon type="download" />{{$t('导出班级明细')}}
          </a-button>
          <table-setting
            :style="{float: 'right'}"
            :table-size.sync="tableSize"
            v-model="columns"
            :refresh-loading="loading"
            @refresh="getList" />
        </div>
        <!-- 数据展示 -->
        <a-table
          :loading="loading"
          size="small"
          rowKey="skuId"
          :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
          @change="handleSortChange"
          :columns="columns"
          :data-source="list"
          :pagination="false"
          :bordered="tableBordered"
        >
        </a-table>
        <a-pagination
          class="ant-table-pagination"
          show-size-changer
          show-quick-jumper
          :pageSizeOptions="pageSizeOptions"
          :current="queryParam.pageNum"
          :total="total"
          :page-size="queryParam.pageSize"
          :showTotal="total => getTotal(total)"
          @showSizeChange="onShowSizeChange"
          @change="changeSize"
        />
      </div>
    </a-card>
  </page-header-wrapper>
</template>

<script>
import {schoolGoodsStudentPage, schoolGoodsStudentStatistics} from '@/api/statistics/school'
import CustomDictTag from "@/components/DictCustomTag";
import {mapGetters} from 'vuex'
import {tableMixin} from '@/store/table-mixin'
import moment from 'moment';
import {pageSchoolGrade} from "@/api/school/schoolGrade";
import {downLoadExcel} from "@/utils/excelDownload";
import * as echarts from 'echarts';
import {getSchoolBatch} from "@/api/school/schoolBatch";


export default {
  name: 'Goods',
  components: {
    CustomDictTag,
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      statisticsInfo: {
        totalCount: 0,
        totalPayAmount: 0
      },
      styleChartData: [],
      stylePieChartInstances: [],
      leaderList: [],
      gradeList: [],
      classList: [],
      schoolId: undefined,
      goodsId: undefined,
      pageSizeOptions: ['10', '20', '50', '100'],
      filteredInfo: {},
      sortedInfo: {},
      selectedRowKeys: [],
      selectedRows: [],
      //预览封面
      previewImageVisible: false,
      previewUrl: false,
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        schoolId: undefined,
        parentId: undefined,
        gradeId: undefined,
        studentName: undefined,
        goodsId: undefined,
        createBeginTime: undefined,
        createEndTime: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: this.$t('订购时间'),
          dataIndex: 'createTime',
          align: 'center'
        },
        {
          title: this.$t('年级'),
          dataIndex: 'parentName',
          align: 'center'
        },
        {
          title: this.$t('班级'),
          dataIndex: 'gradeName',
          align: 'center'
        },
        {
          title: this.$t('姓名'),
          dataIndex: 'studentName',
          align: 'center'
        },
        {
          title: '数量',
          dataIndex: 'goodsCount',
        },
        {
          title: '金额',
          dataIndex: 'payAmount',
        },
        {
          title: '款式',
          dataIndex: 'styleName',
        },
        {
          title: '尺码',
          dataIndex: 'size',
        },
      ]
    };
  },
  filters: {
  },
  created () {
    this.getList()
    this.getGradeList()
  },
  computed: {
    ...mapGetters(['customDict']),
    styleTotalList() {
      return this.styleChartData.map(item => ({
        styleName: item.styleName,
        total: item.pieData.reduce((sum, sizeItem) => sum + (sizeItem.value || 0), 0)
      }))
    },
    allSizeNames() {
      const nameSet = new Set()
      this.styleChartData.forEach(item => {
        (item.pieData || []).forEach(sizeItem => {
          nameSet.add(sizeItem.name)
        })
      })
      return Array.from(nameSet)
    },
    sizeTableColumns() {
      const columns = [
        {
          title: '款式',
          dataIndex: 'styleName',
          align: 'center',
          width: 120
        }
      ]
      this.allSizeNames.forEach(sizeName => {
        columns.push({
          title: String(sizeName),
          dataIndex: `size_${sizeName}`,
          align: 'center',
          width: 80
        })
      })
      columns.push({
        title: '合计',
        dataIndex: 'total',
        align: 'center',
        width: 100
      })
      return columns
    },
    sizeTableData() {
      return this.styleChartData.map(item => {
        const row = {
          styleName: item.styleName,
          total: 0
        }
        this.allSizeNames.forEach(sizeName => {
          const target = (item.pieData || []).find(sizeItem => sizeItem.name === sizeName)
          const value = target ? (target.value || 0) : 0
          row[`size_${sizeName}`] = value
          row.total += value
        })
        return row
      })
    }
  },
  watch: {
   /* '$route.query.schoolId'(schoolId) {
      if (schoolId) {
        this.getList()
      }
    },
    '$route.query.goodsId'(goodsId) {
      if (goodsId) {
        this.getList()
      }
    }*/
  },
  mounted() {
    this.resetQuery();
    window.addEventListener('resize', this.handlePieChartResize);
  },
  beforeDestroy() {
    this.disposeStyleCharts();
    window.removeEventListener('resize', this.handlePieChartResize);
  },
  methods: {
    moment,
    getTotal(total) {
      return this.$t('共')+total+this.$t('条')
    },
    /** 查询商品列表 */
    getList () {
      let schoolId = this.$route.query.schoolId;
      let goodsId = this.$route.query.goodsId;
      this.schoolId = schoolId;
      this.goodsId = goodsId;
      //查询批次所在时间
      getSchoolBatch({id: schoolId}).then(response => {
        this.queryParam.createBeginTime = response.data.startTime;
        this.queryParam.createEndTime = response.data.endTime;
      })
      this.loading = true
      this.queryParam.schoolId = this.schoolId;
      this.queryParam.goodsId = this.goodsId;
      schoolGoodsStudentPage(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
      this.getStatistics()
    },
    getStatistics() {
      schoolGoodsStudentStatistics(this.queryParam).then(response => {
        const data = response.data || {}
        this.statisticsInfo = {
          totalCount: data.totalCount || 0,
          totalPayAmount: data.totalPayAmount || 0
        }
        const stylePieMap = data.stylePieMap || {}
        this.styleChartData = Object.keys(stylePieMap).map(styleName => ({
          styleName,
          pieData: (stylePieMap[styleName] || []).map(item => ({
            name: item.name,
            value: item.value || 0
          }))
        }))
        this.$nextTick(() => {
          this.renderStylePieCharts()
        })
      }).catch(() => {
        this.statisticsInfo = { totalCount: 0, totalPayAmount: 0 }
        this.styleChartData = []
        this.disposeStyleCharts()
      })
    },
    disposeStyleCharts() {
      this.stylePieChartInstances.forEach(chart => {
        if (chart) {
          chart.dispose()
        }
      })
      this.stylePieChartInstances = []
    },
    renderStylePieCharts() {
      this.disposeStyleCharts()
      this.styleChartData.forEach((item, index) => {
        const chartDom = document.getElementById(`stylePieChart-${index}`)
        if (!chartDom) {
          return
        }
        const chart = echarts.init(chartDom)
        chart.setOption({
          tooltip: {
            trigger: 'item'
          },
          legend: {
            orient: 'vertical',
            left: 'left'
          },
          series: [
            {
              name: item.styleName,
              type: 'pie',
              radius: '60%',
              center: ['60%', '55%'],
              data: item.pieData,
              label: {
                formatter: '{b}: {c}'
              }
            }
          ]
        })
        this.stylePieChartInstances.push(chart)
      })
    },
    handlePieChartResize() {
      this.stylePieChartInstances.forEach(chart => {
        if (chart) {
          chart.resize()
        }
      })
    },
    getGradeList() {
      let schoolId = this.$route.query.schoolId;
      pageSchoolGrade({"schoolId": schoolId, "pageNum": 1, "pageSize": 10}).then(response => {
        this.gradeList = response.data.records
      })

    },

    gradeChange(selectId) {
      this.queryParam.gradeId = undefined
      if (!selectId) {
        this.classList = []
        return
      }
      const province = this.gradeList.find(p => p.id  === selectId )
      this.classList = (province && province.children) ? province.children : []
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        schoolId: undefined,
        parentId: undefined,
        gradeId: undefined,
        studentName: undefined,
        goodsId: undefined,
        createBeginTime: undefined,
        createEndTime: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    handleSortChange(pagination, filters, sorter) {
      this.filteredInfo = filters
      this.sortedInfo = sorter
      if (sorter.order) {
        /** 排序字段 sortField **/
        /** 排序方式  sortOrder**/
        this.queryParam.sortField = sorter.columnKey
        this.queryParam.sortOrder = sorter.order === 'ascend' ? 'asc' : 'desc'
        this.getList()
      } else {
        this.queryParam.sortField = '';
        this.queryParam.sortOrder = ''
        this.getList()
      }
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.goodsId)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    previewImageCancel() {
      this.previewImageVisible = false;
    },
    handleRecordPreview(url) {
      this.previewUrl = url
      this.previewImageVisible = true
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },

    /** 导出按钮操作 */
    handleExport () {
      if (!this.queryParam.createBeginTime|| !this.queryParam.createEndTime) {
        this.$message.error("请先选择时间")
        return
      }
      let queryParam = {
        "goodsId": this.goodsId,
        "schoolId": this.schoolId,
        "createBeginTime": this.queryParam.createBeginTime,
        "createEndTime": this.queryParam.createEndTime
      };
      this.$confirm({
        title: this.$t('是否确认导出'),
        onOk () {
          downLoadExcel('biz/admin/statistics/school/goods/sku/student/export' , queryParam)
        },
        onCancel () {}
      })
    },


  }
}
</script>
<style>
.sta-head-footer-table .ant-table-thead > tr > th {
  background-color: #bae7ff !important;
}
.sta-head-footer-table .ant-table-body tr:last-child td {
  background: #fff;
  position: sticky;
  bottom: 0;
  z-index: 1;
  box-shadow: 5px 0 10px #e4e4e4;
}
.statistics-summary-row {
  margin-bottom: 12px;
}
.style-total-card {
  margin-bottom: 12px;
}
.style-total-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 10px;
  background: #fafafa;
  border-radius: 4px;
}
.style-total-name {
  color: #595959;
}
.style-total-count {
  color: #262626;
  font-weight: 600;
}
.statistics-title {
  color: #666;
  font-size: 13px;
}
.statistics-value {
  margin-top: 8px;
  font-size: 22px;
  font-weight: 600;
  color: #1f1f1f;
}
.style-pie-row {
  margin-bottom: 12px;
}
.style-pie-chart {
  height: 260px;
}
.size-table-card {
  margin-bottom: 12px;
}
.size-summary-table .ant-table-thead > tr > th {
  background: #f0f0f0 !important;
}
</style>
